import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOperator } from "../types/OperatorTypes";

interface IOperatorState {
  operator: IOperator | null;
  operators: IOperator[];
  error: string;

  authLoading: boolean;
  operatorsLoading: boolean;
  operatorActionLoading: boolean;

  isAuthChecked: boolean;
}

const initialState: IOperatorState = {
  operator: null,
  operators: [],
  error: "",

  authLoading: false,
  operatorsLoading: false,
  operatorActionLoading: false,

  isAuthChecked: false,
};

export const operatorSlice = createSlice({
  name: "operator",
  initialState,
  reducers: {
    operatorFetching(state) {
      state.authLoading = true;
    },

    operatorFetchSuccess(state, action: PayloadAction<IOperator>) {
      state.authLoading = false;
      state.operator = action.payload;
      state.error = "";
      state.isAuthChecked = true;
    },

    operatorFetchFailed(state, action: PayloadAction<string>) {
      state.authLoading = false;
      state.error = action.payload;
      state.isAuthChecked = true;
    },

    loginLoading(state) {
      state.authLoading = true;
    },

    loginSuccess(state, action: PayloadAction<IOperator>) {
      state.authLoading = false;
      state.error = "";
      state.operator = action.payload;
      state.isAuthChecked = true;
    },

    loginFailed(state, action: PayloadAction<string>) {
      state.authLoading = false;
      state.error = action.payload;
    },

    logoutLoading(state) {
      state.authLoading = true;
      state.error = "";
    },

    logoutSuccess(state) {
      state.authLoading = false;
      state.error = "";
      state.operator = null;
    },

    logoutFailed(state, action: PayloadAction<string>) {
      state.authLoading = false;
      state.error = action.payload;
    },

    addOperatorLoading(state) {
      state.operatorActionLoading = true;
      state.error = "";
    },

    addOperatorSuccess(state, action: PayloadAction<IOperator>) {
      state.operatorActionLoading = false;
      state.error = "";
      state.operators = [...state.operators, action.payload];
    },

    addOperatorFailed(state, action: PayloadAction<string>) {
      state.operatorActionLoading = false;
      state.error = action.payload;
    },

    updateOperatorLoading(state) {
      state.operatorActionLoading = true;
      state.error = "";
    },

    updateOperatorSuccess(state, action: PayloadAction<IOperator>) {
      state.operatorActionLoading = false;
      state.error = "";
      const index = state.operators.findIndex(
        (item) => item.id === action.payload.id
      );
      if (index !== -1) {
        state.operators[index] = action.payload;
      }
    },

    updateOperatorFailed(state, action: PayloadAction<string>) {
      state.operatorActionLoading = false;
      state.error = action.payload;
    },

    deleteOperatorLoading(state) {
      state.operatorActionLoading = true;
      state.error = "";
    },

    deleteOperatorSuccess(state, action: PayloadAction<IOperator>) {
      state.operatorActionLoading = false;
      state.error = "";
      state.operators = state.operators.filter(
        (item) => item.id !== action.payload.id
      );
    },

    deleteOperatorFailed(state, action: PayloadAction<string>) {
      state.operatorActionLoading = false;
      state.error = action.payload;
    },

    getOperatorsLoading(state) {
      state.operatorsLoading = true;
      state.error = "";
    },

    getOperatorsSuccess(state, action: PayloadAction<IOperator[]>) {
      state.operatorsLoading = false;
      state.error = "";
      state.operators = action.payload.filter(
        (item) => item.id !== state.operator?.id
      );
    },

    getOperatorsFailed(state, action: PayloadAction<string>) {
      state.operatorsLoading = false;
      state.error = action.payload;
    },
  },
});

export default operatorSlice.reducer;
